(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-grid"] && !Shopify.designMode) return;
  try {
    
// Set CSS custom property for desktop columns dynamically
document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.custom-collection-grid');
  sections.forEach(section => {
    const desktopColumns = section.querySelector('.custom-collection-grid__wrapper').children.length;
    section.style.setProperty('--desktop-columns', desktopColumns);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-collection-product-grid"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Set CSS custom property for desktop columns dynamically
  const sections = document.querySelectorAll('.custom-collection-grid');
  sections.forEach(section => {
    const desktopColumns = section.querySelector('.custom-collection-grid__wrapper').children.length;
    section.style.setProperty('--desktop-columns', desktopColumns);
  });

  // Add to Cart — AJAX handler
  document.querySelectorAll('.custom-collection-grid__atc-btn').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      var variantId = btn.dataset.variantId;
      var originalText = btn.dataset.originalText;

      if (!variantId || btn.disabled) return;

      // Loading state
      btn.disabled = true;
      btn.textContent = '...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      })
      .then(function(res) {
        if (!res.ok) return res.json().then(function(d) { throw new Error(d.description || 'Failed'); });
        return res.json();
      })
      .then(function() {
        // Success — brief confirmation then reset
        btn.textContent = 'Added!';
        // Notify theme cart systems that may be listening
        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('theme:cart:add'));
        setTimeout(function() {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1500);
      })
      .catch(function() {
        // Error — brief message then reset
        btn.textContent = 'Try again';
        setTimeout(function() {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 2000);
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
